export const ROOT = '/'
export const LANDING = '/ig'
export const LOADING = '/ig/loading'
export const REPORT = '/ig/report'
export const TIPS = '/ig/tips'
